import ReactHtmlParser from "react-html-parser";
import { Box } from "@mui/material";
import type Affiliation from "@/src/_types/Authors/affiliation";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const AuthorAffiliation = (
    {
        affiliations
    }: {
        affiliations: Affiliation[]
    }
) => {
    return (
        <Box
            color="text.primary"
            fontSize={'.8rem'}
            pt={1.5}
        >
            {
                affiliations.map((affiliation: Affiliation) => (
                    ( affiliation.content && affiliation.content !== '' ) &&
                    <Box
                        id={affiliation.id}
                        key={`affiliation-${affiliation.id}`}
                        display="flex"
                        alignItems="baseline"
                        mb={.5}
                    >
                        <SpanTypography
                            color="black"
                            fontSize={'.7rem'}
                            mr={.25}
                            lineHeight={0}
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '1.3rem',
                                minHeight: '1.3rem',
                                borderRadius: '50%',
                                backgroundImage: 'linear-gradient(to right, #ece6e0, #e3dad0)',
                                border: '2px solid #d3b976',
                                boxShadow: '0 1px 2px rgba(51, 51, 51, 0.5)'
                            }}
                        >
                            <SpanTypography fontSize={'.7rem'}>
                                {
                                    affiliation.label
                                }
                            </SpanTypography>
                        </SpanTypography>

                        <SpanTypography fontSize={'.875rem'}>
                            {
                                ReactHtmlParser(affiliation.content)
                            }
                        </SpanTypography>
                    </Box>
                ))
            }
        </Box >
    )
}

export default AuthorAffiliation;